import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	IPageWillMountHandler,
	BrowserWindowSymbol,
	BrowserWindow,
	IPropsStore,
	Props,
} from '@wix/thunderbolt-symbols'
import type { WixCustomElementComponentPageConfig, CustomElementComponent, IWixCustomElementComponent } from './types'
import { name, WixCustomElementComponentAPISymbol } from './symbols'
import { isSSR } from '@wix/thunderbolt-commons'

export const WixCustomElementComponent = withDependencies(
	[named(PageFeatureConfigSymbol, name), BrowserWindowSymbol, Props, optional(WixCustomElementComponentAPISymbol)],
	(
		pageFeatureConfig: WixCustomElementComponentPageConfig,
		window: BrowserWindow,
		propsStore: IPropsStore,
		customElementComponentAPI?: IWixCustomElementComponent
	): IPageWillMountHandler => {
		return {
			async pageWillMount() {
				if (!customElementComponentAPI) {
					return // site feature was not loaded, see it's predicate
				}

				if (isSSR(window)) {
					propsStore.update(
						pageFeatureConfig.customElements.reduce(
							(updatedObject: object, customElement: CustomElementComponent) => ({
								...updatedObject,
								...{
									[customElement.compId]: { isInSeo: pageFeatureConfig.isInSeo },
								},
							}),
							{}
						)
					)
					return
				}

				await customElementComponentAPI.addCustomElements(pageFeatureConfig.customElements)
			},
		}
	}
)
